import { render, staticRenderFns } from "./TransferContractDesignDiplomatiSafiran.vue?vue&type=template&id=42b530d0&"
import script from "./TransferContractDesignDiplomatiSafiran.vue?vue&type=script&lang=js&"
export * from "./TransferContractDesignDiplomatiSafiran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports